import { atom } from 'recoil';

export const timeSavedMetric = atom({
  key: 'timeSavedMetric', // unique ID (with respect to other atoms/selectors)
  default: {
    title: 'Total Time Saved',
    key: 'total',
  },
  // default value (aka initial value)
});
